import React from 'react';
import renderValue from '../../../components/formBuilder/utility/renderValue';
import FormUIOptions from '../../../components/formBuilder/formElements/formUIOptions';
import { DropdownButtonComponent as DropdownButton } from '../../../components';
import classNames from 'classnames';
import { getLift, getMonthly } from './helpers';

export default function RentRow({ unit, isOpen, setOpen, unitNum }) {
  const {
    leaseTerm,
    leaseTermOther,
    leaseStart,
    isOccupied,
    notes,
    numberOfBathrooms,
    numberOfBedrooms,
    numberOfOccupants,
    pastDueRent,
    amountPastDue,
    rent,
    rentDueDate,
    rentDueDateOther,
    marketRent,
    securityDeposit,
    squareFootage,
    tenantNames,
    unitFeatures,
    unitName,
    yearlyRentIncrease,
    newUnit,
  } = unit;

  const rentAmount = getMonthly(rent);
  const marketRentAmount = getMonthly(marketRent);

  const yearlyIncrease =
    yearlyRentIncrease && rentAmount
      ? renderValue(
          {
            name: 'yearlyRentIncrease',
            type: FormUIOptions.UnitMoney,
          },
          {
            yearlyRentIncrease: { ...yearlyRentIncrease, derivedFrom: 'rent' },
            rent: rentAmount,
          }
        )
      : '-';

  const dropDownRow = (name, value, unit) => {
    if (unit && value) {
      switch (unit) {
        case '$':
          value = `$${value}`;
          break;
        default:
          value = `${value} ${unit}`;
          break;
      }
    }

    return (
      <div className="w-full flex justify-between align-middle px-4 pt-1 border-t border-separate border-neutral-100">
        <span className="max-w-[30%] font-medium text-neutral-600 text-left">
          {name}
        </span>
        <span className="max-w-[60%] text-right">{value || '-'}</span>
      </div>
    );
  };

  return (
    <div
      className={classNames(
        'col-span-12 rounded relative',
        unitName === 'Totals'
          ? 'text-white font-medium tracking-wide pb-2'
          : 'text-black font-normal'
      )}
    >
      <div
        className={classNames(
          'grid grid-cols-5rentroll sm:grid-cols-9rentroll -mx-2 text-center',
          unitName === 'Totals' && 'font-semibold'
        )}
      >
        <div
          className={classNames(
            'col-span-3 sm:col-span-7 grid grid-cols-2rentroll sm:grid-cols-7rentroll relative  rounded-md px-2 pt-2 pb-1 ml-1',
            unitName === 'Totals' ? 'bg-neutral-500 pb-2' : 'bg-white'
          )}
        >
          {unitName !== 'Totals' && !newUnit && !isOccupied && (
            <div className="absolute -left-1 -top-[10px] bg-white rounded z-10 px-1 py-0">
              <span className="text-xs text-red-700 tracking-wide">Vacant</span>
            </div>
          )}
          {unitName !== 'Totals' && (
            <div className="absolute top-0 left-0 w-full h-[2px] bg-neutral-300 rounded-t-md"></div>
          )}
          <span>{''}</span>
          <span className="font-semibold">{unitName || 'Unit ' + unitNum}</span>
          <span className="hidden sm:inline">
            {tenantNames
              ? tenantNames.map((name) => name.name).join(', ')
              : '-'}
          </span>
          <span className="hidden sm:inline">
            {numberOfBedrooms || '-'} / {numberOfBathrooms || '-'}
          </span>
          <span className="hidden sm:inline">{leaseStart || '-'}</span>
          <span className="hidden sm:inline ">
            {renderValue(
              { name: 'securityDeposit', type: FormUIOptions.Money },
              { securityDeposit: securityDeposit }
            )}
          </span>
          <span className="">
            {renderValue(
              { name: 'rent', type: FormUIOptions.Money },
              { rent: rentAmount }
            )}
          </span>
        </div>
        <div
          className={classNames(
            'col-span-3 grid grid-cols-3rentrollmobile sm:grid-cols-3rentroll relative  rounded-md px-2 pt-2 pb-1 ml-1 min-w-fit',
            unitName === 'Totals' ? 'bg-primary pb-2' : 'bg-white'
          )}
        >
          {unitName !== 'Totals' && (
            <div className="absolute top-0 left-0 w-full h-[2px] bg-primary rounded-t-md"></div>
          )}
          <span className="col-span-1">
            {renderValue(
              { name: 'marketRent', type: FormUIOptions.Money },
              { marketRent: marketRentAmount }
            )}
          </span>
          <span className="col-span-1">
            {getLift(rentAmount, marketRentAmount)}
          </span>
          <span className=" flex justify-end pr-1 col-span-1">
            {unitName !== 'Totals' && !newUnit && (
              <DropdownButton
                isOpen={isOpen}
                setOpen={setOpen}
                buttonStyles="p-0 max-h-[30px]"
              />
            )}
          </span>
        </div>
      </div>
      {
        //this is the dropdown section
        isOpen && !newUnit && unitName !== 'Totals' && (
          <>
            <div className="flex flex-col sm:flex-row gap-2 w-full p-2 mt-2 justify-center align-middle">
              <div className="flex flex-col gap-1 w-full sm:w-1/2 p-3 rounded  bg-white  text-sm">
                <h3 className="text-left pl-4 text-base font-semibold text-primary">
                  Unit Details
                </h3>
                <span className="inline sm:hidden">
                  {dropDownRow('Bedrooms', numberOfBedrooms)}
                </span>
                <span className="inline sm:hidden">
                  {dropDownRow('Bathrooms', numberOfBathrooms)}
                </span>

                {dropDownRow(
                  'Lease Term',
                  leaseTerm === 'other' ? leaseTermOther : leaseTerm
                )}

                {dropDownRow('Square Feet', squareFootage, 'sq ft')}

                {dropDownRow('Yearly Increase', yearlyIncrease)}

                {dropDownRow(
                  'Unit Features',
                  unitFeatures &&
                    unitFeatures.map((feature) => feature.feature).join(', ')
                )}
                {dropDownRow('Notes', notes)}
              </div>

              <div className="flex flex-col gap-1 w-full sm:w-1/2 p-3 bg-white rounded text-sm">
                <h3 className="text-base text-left pl-4 font-semibold text-primary px-2">
                  Tenant Details
                </h3>
                <span className="inline sm:hidden">
                  {dropDownRow(
                    'Tenant Names',
                    tenantNames &&
                      tenantNames.map((name) => name.name).join(', ')
                  )}
                </span>
                {dropDownRow(
                  'Occupied',
                  isOccupied === false
                    ? 'No'
                    : isOccupied === true
                    ? 'Yes'
                    : '-'
                )}

                {isOccupied !== false && (
                  <>
                    {dropDownRow('Occupants', numberOfOccupants)}
                    <span className="inline sm:hidden">
                      {dropDownRow('Lease Start', leaseStart)}
                    </span>
                    {dropDownRow(
                      'Rent Due Date',
                      rentDueDate === 'other' ? rentDueDateOther : rentDueDate
                    )}
                    <span className="inline sm:hidden">
                      {dropDownRow('Security Deposit', securityDeposit, '$')}
                    </span>
                    {dropDownRow(
                      'Past Due Rent',
                      pastDueRent === false
                        ? 'No'
                        : pastDueRent === undefined
                        ? undefined
                        : 'Yes'
                    )}
                    {pastDueRent &&
                      dropDownRow('Past Due Amount', amountPastDue, '$')}
                  </>
                )}
              </div>
            </div>
          </>
        )
      }
    </div>
  );
}
